module.exports = __webpack_public_path__ + "media/icons/circle-x-filled-4c1370ac.svg";